import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { saveFile } from '../helpers/saveFile';
import { API_ROOT } from '../helpers/apiConfig';

export const actions = {
    searchLocations: (filterRequest) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_LOCATION_REQUEST,
                        types.SEARCH_LOCATION_SUCCESS,
                        types.SEARCH_LOCATION_FAILURE
                    ]
                }
            });
        }
    },
    searchByName: (name) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/name-search',
                    method: 'POST',
                    body: { searchTerm: name },
                    types: [
                        types.SEARCH_LOCATION_NAME_REQUEST,
                        types.SEARCH_LOCATION_NAME_SUCCESS,
                        types.SEARCH_LOCATION_NAME_FAILURE
                    ]
                }
            });
        }
    },    
    loadListFilters: (subscriptionId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId
            }
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/list-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_LOCATION_LIST_FILTERS_REQUEST,
                        types.LOAD_LOCATION_LIST_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_LIST_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadPushdownFilters: (subscriptionId, locationId) => {
        return (dispatch) => {
            const body = {
                subscriptionId,
                locationId
            }
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/pushdown-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_LOCATION_PUSHDOWN_FILTERS_REQUEST,
                        types.LOAD_LOCATION_PUSHDOWN_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_PUSHDOWN_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadFormFilters: (subscriptionId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId
            }
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/form-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_LOCATION_FORM_FILTERS_REQUEST,
                        types.LOAD_LOCATION_FORM_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_FORM_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadLocation: (locationId, subId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/index',
                    method: 'POST',
                    body: { id: locationId, subscriptionId: subId },
                    types: [
                        types.LOAD_LOCATION_REQUEST,
                        types.LOAD_LOCATION_SUCCESS,
                        types.LOAD_LOCATION_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationUserAccess: (subscriptionId, locationId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId,
                locationId: locationId
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/user-access',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_LOCATION_USER_ACCESS_REQUEST,
                        types.LOAD_LOCATION_USER_ACCESS_SUCCESS,
                        types.LOAD_LOCATION_USER_ACCESS_FAILURE
                    ]
                }
            });
        }
    },
    saveLocationUserAccess: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/save-user-access',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SAVE_LOCATION_USER_ACCESS_REQUEST,
                        types.SAVE_LOCATION_USER_ACCESS_SUCCESS,
                        types.SAVE_LOCATION_USER_ACCESS_FAILURE
                    ]
                }
            });
        }
    },
    saveLocation: (location) =>
        (dispatch) => {
            if (location.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'location/create',
                        method: 'POST',
                        body: location,
                        types: [
                            types.CREATE_LOCATION_REQUEST,
                            types.CREATE_LOCATION_SUCCESS,
                            types.CREATE_LOCATION_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'location/update',
                        method: 'PUT',
                        body: location,
                        types: [
                            types.UPDATE_LOCATION_REQUEST,
                            types.UPDATE_LOCATION_SUCCESS,
                            types.UPDATE_LOCATION_FAILURE
                        ]
                    }
                });
            }
    },
    pushdown: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/pushdown',
                    method: 'POST',
                    body: request,
                    types: [
                        types.PUSHDOWN_LOCATION_REQUEST,
                        types.PUSHDOWN_LOCATION_SUCCESS,
                        types.PUSHDOWN_LOCATION_FAILURE
                    ]
                }
            });
    },
    loadDashboardFilters: (keyToLoad) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/dashboard-filters',
                    method: 'POST',
                    body: { locationKeyToLoad: keyToLoad },
                    types: [
                        types.LOAD_LOCATION_DASHBOARD_FILTERS_REQUEST,
                        types.LOAD_LOCATION_DASHBOARD_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_DASHBOARD_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    bulkInactiveLocations: (locationIds) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/bulk-inactive',
                    method: 'POST',
                    body: { locationIds: locationIds },
                    types: [
                        types.BULK_INACTIVE_LOCATIONS_REQUEST,
                        types.BULK_INACTIVE_LOCATIONS_SUCCESS,
                        types.BULK_INACTIVE_LOCATIONS_FAILURE
                    ]
                }
            });
        }
    },
    bulkUpdateAttributes: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/bulk-update-attributes',
                    method: 'POST',
                    body: request,
                    types: [
                        types.BULK_LOCATION_ATTRIBUTES_REQUEST,
                        types.BULK_LOCATION_ATTRIBUTES_SUCCESS,
                        types.BULK_LOCATION_ATTRIBUTES_FAILURE
                    ]
                }
            });
        }
    },
    import: (subscriptionId, file) =>
        (dispatch) => {
            let body = new FormData();
            body.append('file', file);
            body.append('subscriptionId', subscriptionId);

            return dispatch({
                [CALL_API]: {
                    endpoint: 'location/import',
                    method: 'POST',
                    body: body,
                    types: [
                        types.IMPORT_LOCATION_REQUEST,
                        types.IMPORT_LOCATION_SUCCESS,
                        types.IMPORT_LOCATION_FAILURE
                    ]
                }
            });
        },
    importTemplate: () => {
        return (dispatch, getState) => {
            const endpoint = 'location/import-template';
            const method = 'GET';
            let headers = {};
            const token = getState().user.accessToken;
            if (typeof token === "string") {
                headers.Authorization = `Bearer ${token}`;
            }
            const subscriptionId = getState().user.currentSubscriptionId;
            if (subscriptionId) {
                headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
            }

            return (
                // eslint-disable-next-line no-undef
                fetch(`${API_ROOT}${endpoint}`, {
                    method,
                    headers,
                    credentials: "same-origin"
                })
                .then(async response => {
                    await saveFile(response);
                })
                .catch(error => {
                    return error;
                })
            );
        }
    },
}
